import { Text } from '@simplywallst/ui-core';

import { generateEventBasedReminderMessage } from '@/components/NoteReminder/utils/reminderMessage';
import { validateTargetSharePrice } from '@/components/NoteReminder/utils/validator';
import type { Note } from '@/components/Note/hooks/useNote';

export interface EventBasedReminderMessageProps {
  company?: Note['company'];
  targetSharePrice: string;
}

const EventBasedReminderMessage = ({
  company,
  targetSharePrice,
}: EventBasedReminderMessageProps) => {
  if (typeof company !== 'undefined') {
    const currentSharePrice =
      company?.analysisValue?.lastSharePrice ?? undefined; // TODO: Suggest refactoring so any logic further down handles only number | null and we don't introduce undefined
    const currencyISO = company?.listingCurrencyISO;
    const isValidTargetSharePrice = validateTargetSharePrice(
      targetSharePrice,
      currentSharePrice
    );
    const parsedTargetSharePrice = parseFloat(targetSharePrice);

    if (
      currentSharePrice === undefined ||
      currencyISO === undefined ||
      !isValidTargetSharePrice
    ) {
      return null;
    }

    if (parsedTargetSharePrice >= 0) {
      const variation =
        parsedTargetSharePrice > currentSharePrice ? 'exceeds' : 'drops below';
      return (
        <Text typography="xSmall" color="mediumGray">
          {generateEventBasedReminderMessage(
            parsedTargetSharePrice,
            currencyISO,
            variation
          )}
        </Text>
      );
    }
  }

  return null;
};

export default EventBasedReminderMessage;
